import * as React from "react";
const SvgDelivery = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "delivery_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "delivery_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.12 8.72a.94.94 0 0 0 1-.86.94.94 0 0 0-1-.86H1.46a.94.94 0 0 0-1 .86.94.94 0 0 0 1 .86ZM11 10.81a.94.94 0 0 0-1-.81H5.29a.94.94 0 0 0-1 .86.94.94 0 0 0 1 .86H10a.94.94 0 0 0 1-.91M2.74 12.91a.93.93 0 0 0-1 .86.93.93 0 0 0 1 .85h3a.93.93 0 0 0 1-.85.93.93 0 0 0-1-.86Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m22.38 13.61-1.7-4a1 1 0 0 0-.32-.4L19.9 6a1 1 0 0 0-1-.86h-3.44V4a1 1 0 0 0-1-1H2.29a1 1 0 0 0 0 2h11.17v5a1 1 0 0 0 1 1h4.64l1.36 3.2V17h-1.78a3 3 0 0 0-4.44 0H9.68a3 3 0 0 0-4.44 0H2.29a1 1 0 1 0 0 2h2.17a3 3 0 0 0 6 0h3a3 3 0 0 0 6 0h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-.08-.39M15.46 7.1H18l.31 1.9h-2.85Zm-8 12.9a1 1 0 1 1 1-1 1 1 0 0 1-1 1m9 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1",
	style: { fill: "currentColor" }
}))));
export default SvgDelivery;
